// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3e13C","range":"MonthRangeSwitch_range__5J8D2","disabled":"MonthRangeSwitch_disabled__rIZa9"};